import { PropertyConstructionCostRecordRow } from "../../property-construction-costs/types";
import { ConstructionCostRecordRow } from '../../construction-costs/types'
import { CostAssessmentRecordRow } from '../types'
export function toCostAssessmentRecord(
  records: PropertyConstructionCostRecordRow[] | ConstructionCostRecordRow[]
): CostAssessmentRecordRow[] {
  return records.map(item => {
    if (item.kind === 'header') return item
    const periodValues = item.periodValues
    if (periodValues.length > 0) {
      return {
        ...item,
        old_quantity: item.quantity ? item.quantity : 0,
        quantity: item.quantity ? item.quantity : 0,
        unit_rate: periodValues[periodValues.length - 1].value,
        useful_life: item.useful_life ? item.useful_life : 0,
        unit: item.unit ? item.unit : null,
        isRemoved: item.isRemoved === undefined ? false : item.isRemoved
      }
    }
    return {
      ...item,
      useful_life: item.useful_life ? item.useful_life : 0,
      old_quantity: item.quantity ? item.quantity : 0,
      quantity: item.quantity ? item.quantity : 0,
      unit: item.unit ? item.unit : null,
      unit_rate: null,
      isRemoved: item.isRemoved === undefined ? false : item.isRemoved
    }
  })
}

export function toPropertyConstructionCostRecord(records: CostAssessmentRecordRow[]): PropertyConstructionCostRecordRow[] {
  return records.map(item => {
    if (item.kind === 'header') return item
    return {
      ...item,
      periodValues: [{value: item.unit_rate, premium: null}]
    }
  })
}